// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HDtb7{display:inline-flex;justify-content:center;align-items:center;position:relative}.HDtb7 button{display:inline-flex !important;justify-content:center !important;align-items:center !important;gap:4px !important}.HDtb7 button svg{width:18px !important;height:18px !important}.HDtb7 button>span{display:inline-flex;align-items:center;justify-content:center}.ALVNH{font-size:14px;font-weight:600;line-height:1}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"variableInsertButtonWrapper": `HDtb7`,
	"bracesIcon": `ALVNH`
};
export default ___CSS_LOADER_EXPORT___;
